module.exports = __webpack_public_path__ + "img/prop-rocket-left.1810ba52.png";